import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { GetAdminSyncBatchListSyncTypeEnum } from '@api/generated/portal-be-admin';
import { SyncBatchListPage } from '@features/admin/sync-batches';
import { useAdminSyncBatchStore } from '@features/admin/sync-batches/useAdminSyncBatchStore.ts';

const adminSyncBatchesSearchSchema = z.object({
  syncType: z.nativeEnum(GetAdminSyncBatchListSyncTypeEnum).optional(),
  status: z.enum(['PENDING', 'COMPLETED', 'WARNING', 'FAILED']).optional(),
  author: z.string().optional(),
  // Pozor na z.coerce.boolean() — ten by ze stringu "false" udělal true, takže by ručně
  // poslaný odkaz s ?onlyWithPrices=false filtr naopak zapnul.
  onlyWithPrices: z
    .union([z.boolean(), z.literal('true'), z.literal('false')])
    .transform(v => v === true || v === 'true')
    .optional(),
  requestId: z.string().optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export type AdminSyncBatchesSearch = z.infer<typeof adminSyncBatchesSearchSchema>;

export const Route = createFileRoute('/admin/sync-batches/')({
  validateSearch: search => adminSyncBatchesSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { syncType, status, author, onlyWithPrices, requestId, page, size } = ctx.search;
    useAdminSyncBatchStore.getState().loadBatches({
      syncType,
      status,
      author,
      onlyWithPrices,
      requestId,
      page: page || 1,
      size: size || 20,
    });
  },
});

function RouteComponent() {
  return <SyncBatchListPage />;
}
